import { render, staticRenderFns } from "./MResult.vue?vue&type=template&id=cac72702&scoped=true&"
import script from "./MResult.vue?vue&type=script&lang=ts&"
export * from "./MResult.vue?vue&type=script&lang=ts&"
import style0 from "./MResult.vue?vue&type=style&index=0&id=cac72702&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac72702",
  null
  
)

export default component.exports